<template>
    <div class="layout"
        :class="typeClass"
        ref="layoutRef"
    >
        <TheHeader class="layout__header" />
        <div class="layout__content">
            <slot />
        </div>
        <TheFooter class="layout__footer" />
    </div>
</template>

<script>
import TheHeader from './TheHeader.vue';
import TheFooter from './TheFooter.vue';

const TYPES = ['base']

export default {
    name: 'TheLayout',
    components: {
        TheHeader,
        TheFooter
    },
    props: {
        type: {
            type: String,
            required: true,
            validator: function(type) {
                return TYPES.includes(type);
            }
        }
    },
    computed: {
        typeClass() {
            return `layout--${this.type}`;
        }
    }
}
</script>

<style scoped lang="scss">
.layout {
    &--base {
        padding-top: rem($gap-big);
        padding-bottom: rem($gap-big);

        @media #{$screen-big} {
            padding-top: rem($gap-medium);
            padding-bottom: rem($gap-medium);
        }

        @media (#{$screen-small}) {
            padding-top: rem($gap-small);
            padding-bottom: rem($gap-small);
        }
    }

    &--base & {
        &__header {
        }

        &__content {
            padding-top: $gap-large;
            padding-bottom: $gap-large;

            @media #{$screen-big} {
                padding-top: rem(40px);
                padding-bottom: rem(40px);
            }

            @media #{$screen-medium} {
                padding-top: rem(45px);
            }
        }

        &__footer {
        }
    }
}
</style>